import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';
import cx from 'classnames';
import { setScrollIndicator } from '../actions';

class ScrollIndicator extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      fadeOut: false,
    };

    this.fadeOutTimer = null;
    this.resetTimer = null;

    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillReceiveProps(nextProps) {
    const { isVisible } = nextProps;

    if (isVisible) {
      this.fadeOut();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  fadeOut(delay = 3000) {
    const { hideScrollIndicator } = this.props;

    if (this.fadeOutTimer) {
      window.clearTimeout(this.fadeOutTimer);
    }

    if (this.resetTimer) {
      window.clearTimeout(this.resetTimer);
    }

    // Fade indicator out after $delay seconds
    this.fadeOutTimer = window.setTimeout(() => this.setState({ fadeOut: true }), delay);
    // After fade out animation of 0.5s reset component state
    this.resetTimer = window.setTimeout(() => {
      this.setState({ fadeOut: false });
      hideScrollIndicator();
    }, delay + 500);
  }

  handleScroll() {
    const { isVisible } = this.props;

    if (isVisible) {
      this.fadeOut(0);
    }
  }

  handleOnClick(e) {
    const { lastQuestionId, isResultsButtonVisible, hideScrollIndicator } = this.props;

    e.preventDefault();
    e.stopPropagation();

    let scrollElementName = null;

    if (isResultsButtonVisible) {
      scrollElementName = 'resultButton';
    } else {
      scrollElementName = `question_${lastQuestionId}`;
    }

    scroller.scrollTo(scrollElementName, {
      smooth: 'easeInQuad',
      duration: 1000,
      delay: 550,
    });

    hideScrollIndicator();
  }

  render() {
    const { isVisible } = this.props;
    const { fadeOut } = this.state;

    if (!isVisible) {
      return null;
    }

    const classes = cx('scrollIndicator', {
      'scrollIndicator--hidden': fadeOut,
    });

    return (
      <a href="#" className={classes} onClick={this.handleOnClick}>
        <svg xmlns="http://www.w3.org/2000/svg" width="72" height="26" viewBox="0 0 72 26">
          <path fill="#5C9ACA" fillRule="evenodd" d="M224,632 L188,658 L152,632 L224,632 Z M221,632 L155,632 L188,656 L221,632 Z" transform="translate(-152 -632)" />
        </svg>
      </a>
    );
  }
}

ScrollIndicator.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  lastQuestionId: PropTypes.string.isRequired,
  isResultsButtonVisible: PropTypes.bool.isRequired,
  hideScrollIndicator: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    isVisible: state.configurator.showScrollIndicator,
    lastQuestionId: state.configurator.lastQuestionId,
    isResultsButtonVisible: state.configurator.showResults,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    hideScrollIndicator: () => setScrollIndicator(false)(dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScrollIndicator);



// WEBPACK FOOTER //
// ./src/components/ScrollIndicator.js